import { runInnerFunction, runInnerFunction2 } from "../../compatManager";
import { v4 as uuidv4 } from "uuid";

export type DefectUndertakingType = {
    name: string;
    id: string;
    Date1: string; 
    Date2: string; 
    CustomDate1: string; // set 1 for manually changed date
    CustomDate2: string; 
    SentDate1: string; // 
    SentDate2: string;
    SentBy1: string;
    SentBy2: string;
    EmailData: any;
    CalendarData: any;
}

export type UndertakingItemType = {
    id: string;
    name: string;
    desc?: string;
    Date1: string;
    Date2: string;
    CustomDate1: string;
    CustomDate2: string;
    SentDate1: string;
    SentDate2: string;
    SentBy1: any;
    SentBy2: any;
    CanAutoFollowUp: boolean;
    CompletedDate?: string;
    emailOk?: boolean;
    CompletedBy?: string;
    escalationEmail?: string;
    registeredSecurityNum?: string;
    followupHistory?: string;
    notifyHistory?: string;
    DueDate: string;
}

type UndertakingPreferencesType = {
    offset1: number,
    offset2: number,
}

export async function saveUndertakings(SESSION_INFO, dataroot){
    const rwapi = process.env.REACT_APP_RWAPI_ENDPOINT;
    let s = await fetch(`/${rwapi}/api/${SESSION_INFO.appProvinceShort}/${SESSION_INFO.firm.id}/undertakingprep?SessionID=${SESSION_INFO.sid}`)
    let data = await s.json();
    let res: {offset1: number, offset2: number};
    // console.log(data)
    if(data.ok){
        let result = JSON.parse(data.result);
        res = {offset1: result.first, offset2: result.second + result.first}
    } else {
        console.log("failed to get preferences")
        return;
    }
    if(!res || !res.offset1 || !res.offset2){
        console.log("failed", res);
        return;
    }
    // console.log(res)
    let json = SaveUndertaking(dataroot, SESSION_INFO.appProvinceShort, res)
    // console.log("Saving", json)
    if(!json) return;
    let body = {AppID: dataroot.getAttribute("AppID"), Data: json}
    const response = await fetch(`/${rwapi}/api/${SESSION_INFO.appProvinceShort}/${SESSION_INFO.firm.id}/save/undertaking?SessionID=${SESSION_INFO.sid}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    });
    const payload = await response.json();
    if (!payload?.ok) {
        throw new Error(payload?.error || "Failed to save preferences.");
    }
    // console.log(payload)
}

function SaveUndertaking(dataroot: any, province: string, res: UndertakingPreferencesType){

    let closing = dataroot.getAttribute("ClosingDate");
    if(!closing){
        console.log("Cannot save undertakings: No closing date")
        return null;
    }
    let undertakings = getDefectUndertakings(dataroot, closing, res.offset1, res.offset2, province);
    // let followUp = getFollowUp();

    let json = UndertakingJson(undertakings, province);
    // console.log(json)
    return json;
}

function UndertakingJson(data: Array<DefectUndertakingType>, province: string) {
    let c = data.map(defect => {

        // console.log(getBusinessDate(province, "after", 60))
        return {
            ...defect,
            // Date1: date1,
            // Date2: date2,
            EmailData: JSON.stringify(defect.EmailData),
            CalendarData: JSON.stringify(defect.CalendarData),
        }
    }).filter(e => e.Date1 > "" && e.Date2 > "");
    return c
}

export function OffsetDays(date: string, offset: number, province: string){
    if(!offset) return null;
    let d = new Date(`${date}T00:00:00.000Z`);
    if(isNaN(d.getTime())) return null;
    // d.setMinutes(d.getMinutes() + d.getTimezoneOffset())
    // d.setHours(d.getHours() + 8);
    d.setUTCDate(d.getUTCDate() + offset)
    let finalDate = NextNonHoliday(d, province);
    return finalDate.toISOString().substring(0, 10);
}

function NextNonHoliday(date: Date, province: string){
    let holiday = runInnerFunction2("generateYearHolidays", [date.getFullYear().toString(), province]).map((d: Date) => d.toISOString().substring(0, 10));
    let d = date;
    // console.log(holiday.map(e => e.toISOString()))
    while([0, 6].includes(d.getUTCDay()) || holiday.some((e: string) => e === d.toISOString().substring(0, 10))){ 
        d.setUTCDate(d.getUTCDate() + 1)
    }
    return d;
}

export function getMailList(dataroot: any, PSM: any, defectId: any, mode: "followup" | "notify" = "followup"){
    let to = [], cc = [];
    const defectNode = dataroot.selectSingleNode(`Defect[@DefectId='${defectId}']`);
    const isDischarge = defectNode?.getAttribute("type") === "32_2";

    const pushSolicitor = () => {
        // Other-side Responsible Lawyer (To) + first Firm Contact with email (CC).
        const sol = dataroot.selectSingleNode("Solicitor");
        const lawyerEmail = sol?.getAttribute("FirmEmail") || "";
        if(lawyerEmail) to.push(lawyerEmail);
        const contactPeople = sol?.selectNodes("ContactPeople") || [];
        for(let i = 0; i < contactPeople.length; i++){
            const email = contactPeople[i].getAttribute("ContactEmail") || "";
            if(email){
                cc.push(email);
                break;
            }
        }
    };

    if(PSM === "S"){
        if(mode === "notify"){
            // Sale Notify: Buyer side — Responsible Lawyer + Firm Contact (discharge or not).
            pushSolicitor();
        } else if(isDischarge){
            // Sale Follow Up + Discharge → Lender escalation email.
            const lenderNode = defectNode?.selectSingleNode("Data/Lender");
            to.push(lenderNode?.getAttribute("EscalationEmail") || "");
        }
        // Sale Follow Up + non-discharge → leave blank.
    } else if(PSM === "M"){
        // Mortgage: Discharge → Lender; any other issue → blank.
        if(isDischarge){
            const lenderNode = defectNode?.selectSingleNode("Data/Lender");
            to.push(lenderNode?.getAttribute("EscalationEmail") || "");
        }
    } else {
        // Purchase: Responsible Lawyer + Firm Contact for all issues.
        pushSolicitor();
    }
    return {to: to, cc: cc};
}

function getDefectUndertakings(dataroot: any, closing: string, offset1: number, offset2: number, province: string): Array<DefectUndertakingType> {
    let undertakings = [];
    let PSM = dataroot.getAttribute("PSM");

    let reLine = dataroot.getAttribute("ReLine");
    let address = dataroot.getAttribute("PropertyAddress");
    let defects = dataroot.selectNodes("Defect");
    let needSave = false;
    defects.forEach(node => {
        if(true){ // need to save every defect not just undertaking === 1 so data remains if undertaking is unchecked
            let defectId = node.getAttribute("DefectId");
            let dataNode = node.selectSingleNode("Data");
            const get = (attr) => dataNode?.getAttribute(attr) || "Unknown"

            let FuNode = dataNode?.selectSingleNode("Followup");
            if(!FuNode){
                FuNode = dataNode.ownerDocument.createElement('Followup');
                dataNode.appendChild(FuNode);
            }
            let mailList = getMailList(dataroot, PSM, defectId);
            let desc = buildDesc(node)
            let date1 = FuNode.getAttribute('Date1'), date2 = FuNode.getAttribute('Date2');
            // console.log("dates", date1, date2)
            let disable = dataroot.getAttribute("DisableUndertakingEmail") === "1" || node.getAttribute('type') !== "32_2";
            let isUndertaking = node.getAttribute("Undertaking") === "1" && (dataNode?.getAttribute("VendorLawyerUndertaking") === "1" || PSM === "M") ;
            const name = node.getAttribute("name")
            let taskName = node.getAttribute('type') === "32_2"? `${name} - ${dataNode?.getAttribute("Lender") || "Unknown Lender"}` : name 
            // if(FuNode.getAttribute('CustomDate1') !== "1"){
            //     date1 = OffsetDays(closing, offset1, province);
            //     FuNode.setAttribute('Date1', date1);
            // }
            // if(FuNode.getAttribute('CustomDate2') !== "1"){
            //     date2 = OffsetDays(closing, offset2, province);
            //     FuNode.setAttribute('Date2', date2);
            // }
            if(defectId == null){
                const newId = uuidv4();
                defectId = newId;
                node.setAttribute("DefectId", newId);
                needSave = true 
            }
            undertakings.push({
                name: node.getAttribute("name"),
                id: defectId,
                Date1: date1,
                Date2: date2,
                CustomDate1: FuNode?.getAttribute("CustomDate1"),
                CustomDate2: FuNode?.getAttribute("CustomDate2"),
                SentDate1: FuNode?.getAttribute("SentDate1"),
                SentDate2: FuNode?.getAttribute("SentDate2"),
                SentBy1: FuNode?.getAttribute("SentBy1"),
                SentBy2: FuNode?.getAttribute("SentBy2"),
                Disable: disable? "1":"0",
                UndertakingChecked: isUndertaking? "1":"0",
                EmailData: {
                    to: mailList.to || [], 
                    cc: mailList.cc || [],
                    lender: get("Lender"),
                    reline: reLine, 
                    address: address,
                    PSM: PSM,
                    closing: dataroot.getAttribute("ClosingDate"),
                    ref: get("MortgageReferenceNo"),
                    desc: desc,
                },
                CalendarData: {
                    // fileName: dataroot.getAttribute("MatterNumber") || "",
                    // propertyAddress: address || "",
                    // firmContact: dataroot.getAttribute("StaffName") || "",
                    // firmContactId: dataroot.getAttribute("FirmContactID") || 0,
                    title: taskName,
                    // psm: PSM,
                    // reline: reLine,
                    // clientName: dataroot.getAttribute("ClientName") || "",
                }
            })
        }
    })

    return undertakings;
}
export function getAllUndertaking(dataroot: any): UndertakingItemType[]{
    let nodes;
    if(dataroot.getAttribute("PSM") === "M") nodes = dataroot.selectNodes("Defect[@Undertaking='1']");
    else nodes = dataroot.selectNodes("Defect[@Undertaking='1' and not(not(Data/@VendorLawyerUndertaking)) and Data/@VendorLawyerUndertaking='1']");
    let val = nodes.map(node => {
        if(!node.getAttribute('DefectId')) node.setAttribute('DefectId', uuidv4());
        // console.log(node)
        let newNode: UndertakingItemType = {
            id: "",
            name: "",
            Date1: "",
            Date2: "",
            CustomDate1: "",
            CustomDate2: "",
            SentDate1: "",
            SentDate2: "",
            SentBy1: "",
            SentBy2: "",
            CanAutoFollowUp: false,
            CompletedDate: "",
            DueDate: "",
        };
        const data = node.selectSingleNode('Data');
        const fua = data?.selectSingleNode('Followup');
        const lender = node?.selectSingleNode('Data')?.selectSingleNode('Lender');
        newNode.id = node.getAttribute('DefectId');
        newNode.CanAutoFollowUp = node.getAttribute('type') === "32_2";
        if(newNode.CanAutoFollowUp){
            let mail = ( dataroot.getAttribute("PSM") === "P"?
                dataroot?.selectSingleNode('Solicitor')?.getAttribute("FirmEmail") : 
                lender?.getAttribute('EscalationEmail')
            ) || ""
            newNode.emailOk = checkEmail(mail);
            newNode.escalationEmail = lender?.getAttribute('EscalationEmail') || "";
        }
        newNode.CompletedDate = data.getAttribute('DateCompliedWith') || undefined;
        newNode.name = node.getAttribute('name');
        newNode.desc = buildDesc(node);
        newNode.registeredSecurityNum = node.getAttribute("DischargeInstrumentNumber");
        newNode.followupHistory = fua?.getAttribute('FollowupHistory');
        newNode.notifyHistory = fua?.getAttribute('NotifyHistory');
        // console.log(fua.getAttribute('FollowupHistory'))
        // console.log(fua)
        if(fua){
            for(const att of "Date1 Date2 CustomDate1 CustomDate2 SentDate1 SentDate2 SentBy1 SentBy2 CompletedBy DueDate".split(" ")){
                // console.log(fua.getAttribute(att))
                newNode[att] = fua.getAttribute(att);
            }
        }
        // console.log(j)
        return newNode;
    });
    // console.log(val)
    return val.filter(i => i.id > "");
}

export function buildDesc(defectNode: any): string{
    let dataNode = defectNode?.selectSingleNode("Data");
    if(!dataNode) return "";
    // const desc = dataNode.selectSingleNode("Description")?.childNodes;
    // if(!desc) return ""
    // return desc.map(node => {
    //     if(node.nodeName === "#text") return node.nodeValue;
    //     if(node.nodeName === "SPAN") return dataNode.getAttribute(node.getAttribute("attrName")) || "_";
    //     return ""
    // }).join("");
    if(defectNode.getAttribute("type") !== "32_2") return "";
    const lender = dataNode.getAttribute("Lender") || "_";
    const instrumentNumber = dataNode.getAttribute("InstrumentNumber") || "_";
    const position = dataNode.getAttribute("Priority") || "_";
    return `Instrument No. ${instrumentNumber} is a ${position} Charge/Mortgage of Land to and in favour of ${lender}`
}

export function getUndertakingDataNode(defectId: string, dataroot: any){ 
    let undertakingData = dataroot?.selectSingleNode(`Defect[@DefectId='${defectId}']`)?.selectSingleNode('Data');
    if(undertakingData){
        let dataNode = undertakingData.selectSingleNode('Followup');
        if(!dataNode){
            dataNode = undertakingData.ownerDocument.createElement('Followup');
            undertakingData.appendChild(dataNode);
        }
        return dataNode;
    }
    return null;
}

// export function finishFollowup(num: number, dataroot: any, defectId: string, date: string, by: string){ //send email 
//     if(![1, 2].includes(num)) return;
//     let dataNode = getUndertakingDataNode(defectId, dataroot);
//     if(dataNode){
//         dataNode.setAttribute(`SentDate${num}`, date);
//         dataNode.setAttribute(`SentBy${num}`, by);
//         runInnerFunction("SetPageDirty", null);
//     } else {
//         console.log(`Unable to find defect with id: ${defectId}`);
//     }
// }

function checkEmail(email: string){ // super super basic just check stuff thats obviously wrong
    // console.log("check", email)
    return email.search(/.+@.+\..+/g) == 0;
}

export function genDocument(id: string) {
    const mockElement = document.createElement('div');
    
    runInnerFunction2('PreviewLinkedIssueDocument', [
        mockElement,
        id,
        "",
        null,
        "",
        "generate"
    ]);    
} 

/**
 * Assigns a UUID to `DefectId` on every `Defect` with `Undertaking="1"` when the id is missing or blank.
 * Matches undertaking discovery in `readUndertakingsFromXml` (all undertaking types, not only `32_2`).
 * @returns true if any node was updated
 */
function assignMissingUndertakingDefectIds(dataroot: any): boolean {
    if (!dataroot || typeof dataroot.selectNodes !== "function") return false;
    const defects = dataroot.selectNodes("Defect");
    if (!defects) return false;
    let mutated = false;
    const visit = (node: any) => {
        if (node?.getAttribute?.("Undertaking") !== "1") return;
        const raw = node.getAttribute?.("DefectId");
        if (raw != null && String(raw).trim() !== "") return;
        node.setAttribute("DefectId", uuidv4());
        mutated = true;
    };
    if (typeof defects.forEach === "function") {
        defects.forEach(visit);
    } else {
        const len = (defects as { length?: number }).length ?? 0;
        for (let i = 0; i < len; i++) visit((defects as any)[i]);
    }
    return mutated;
}

// /** Call when live file XML is loaded so undertaking tasks can key off stable `DefectId` (see `undertakingTaskLinkKey`). */
// export function ensureUndertakingDefectIds(dataroot: any): boolean {
//     const mutated = assignMissingUndertakingDefectIds(dataroot);
//     if (mutated) {
//         runInnerFunction("SetPageDirty", null);
//     }
//     return mutated;
// }


export function finishFollowup(num: number, dataroot: any, defectId: string, date: string, by: string){ //send email 
    if(![1, 2].includes(num)) return;
    let dataNode = getUndertakingDataNode(defectId, dataroot);
    if(dataNode){
        dataNode.setAttribute(`SentDate${num}`, date);
        dataNode.setAttribute(`SentBy${num}`, by);
        runInnerFunction("SetPageDirty", null);
    } else {
        console.log(`Unable to find defect with id: ${defectId}`);
    }
}